import * as React from 'react';
import { connect } from 'react-redux';
import { goBack, push } from 'react-router-redux';
import * as queryString from 'query-string';

import {
  IconButton,
  BookingCreateForm,
  HeadingSection,
  RouteWrapper,
  Section,
} from '../../components';

interface Props {
  dispatch: Function;
}

class Route extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  render() {
    const query = queryString.parse(window.location.search);
    let breadcrumbs = [{ link: `/bookings/create`, text: 'Create Booking' }];
    if (query && query.start_date) {
      breadcrumbs = [
        { link: '/availabilities', text: 'Availabilities' },
        { link: `/bookings/create`, text: 'Create Booking' },
      ];
    }
    return (
      <RouteWrapper
        title="New Booking"
        requireAuth
        requirePermission="MANAGE_BOOKINGS"
        breadcrumbs={breadcrumbs}
      >
        <HeadingSection
          title="New Booking"
          controls={[
            <IconButton
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
              key="return"
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <div className="columns">
            <div className="column is-12-desktop is-7-widescreen">
              <BookingCreateForm
                onUpdate={(booking) => {
                  this.props.dispatch(push(`/bookings/${booking.id}`));
                }}
              />
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

export default connect()(Route);
